import { createSlice } from "@reduxjs/toolkit";

import { type PolicyStateType } from "../interfaces";

const initialState: PolicyStateType = {
  isLoading: false,
  policies: [],
};

const policySlice = createSlice({
  name: "policy",
  initialState,
  reducers: {
    setPolicyLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setPolicies: (state, action) => {
      state.policies = action.payload;
    },
  },
});

export const { setPolicyLoading, setPolicies } = policySlice.actions;
export default policySlice.reducer;
